/**
 * Utils for text
 *
 * @example
 * const text = textHandle('Hello, WORLD!');
 * text.getValue(); // 'Hello, WORLD!'
 * text.isEmpty(); // false
 * text.capitalize(); // 'Hello, World!'
 * text.capitalizeFirstLetter(); // 'Hello world'
 */

export function textHandle(value: string) {
	return {
		getValue(): string {
			return value;
		},
		isEmpty() {
			return value.trim() === '';
		},
		capitalize() {
			if (this.isEmpty()) {
				return '';
			}
			return value.toLowerCase().replace(/(^\w|\s\w)/g, match => match.toUpperCase());
		},
		capitalizeFirstLetter() {
			if (this.isEmpty()) {
				return '';
			}
			const firstLetter = value.charAt(0).toUpperCase();
			const restOfString = value.slice(1).toLowerCase();
			return `${firstLetter}${restOfString}`.trim();
		},
		removeSpecialChar() {
			if (this.isEmpty()) {
				return '';
			}
			return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		},
		sanitizeText() {
			if (this.isEmpty()) {
				return '';
			}
			return value
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^a-zA-Z0-9\s+-]/g, '')
				.trim()
				.toLowerCase();
		},
	};
}
